const SPOTLIGHT_SELECTORS = [
  '.react-joyride__spotlight',
  '[class*="react-joyride__spotlight"]'
];

export const resolveTutorialTarget = (target) => {
  if (!target) {
    return null;
  }

  if (typeof target === 'string') {
    return document.querySelector(target);
  }

  if (target instanceof HTMLElement) {
    return target;
  }

  return null;
};

const getSpotlightElement = () => {
  for (const selector of SPOTLIGHT_SELECTORS) {
    const element = document.querySelector(selector);
    if (element) {
      return element;
    }
  }

  return null;
};

export const positionTutorialSpotlight = (targetElement, padding = 8) => {
  const spotlight = getSpotlightElement();
  if (!spotlight || !targetElement) {
    return;
  }

  const rect = targetElement.getBoundingClientRect();
  if (!rect.width && !rect.height) {
    return;
  }

  const top = Math.max(0, rect.top - padding);
  const left = Math.max(0, rect.left - padding);
  const width = rect.width + padding * 2;
  const height = rect.height + padding * 2;

  spotlight.style.position = 'fixed';
  spotlight.style.transform = 'none';
  spotlight.style.margin = '0';
  spotlight.style.top = `${top}px`;
  spotlight.style.left = `${left}px`;
  spotlight.style.width = `${width}px`;
  spotlight.style.height = `${height}px`;
};
